import { render } from "./Profile_c.vue?vue&type=template&id=71108c0a"
import script from "./Profile_c.vue?vue&type=script&lang=js"
export * from "./Profile_c.vue?vue&type=script&lang=js"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__